import { Drawer as Drawer$1, DrawerHeader, DrawerBody } from './Drawer.js';

const Drawer = Object.assign(Drawer$1, {
    Header: DrawerHeader,
    Body: DrawerBody,
});

export { Drawer };
